import { AppointmentTask } from '../types';

const getTasksKey = (tenantId: string, userId: string) =>
  `PERSIST_APPOINTMENT_TASKS_${tenantId}_${userId}`;

export const persistAppointmentTasks = (
  tenantId: string,
  userId: string,
  tasks: AppointmentTask[],
) => {
  // Operation could fail due to storage quota, private browsing mode, or other exceptions
  try {
    localStorage.setItem(getTasksKey(tenantId, userId), JSON.stringify(tasks));
  } catch {
    // What do we do here?
  }
};

export const getPersistedTasks = (
  tenantId: string,
  userId: string,
): AppointmentTask[] => {
  const tasksJson = localStorage.getItem(getTasksKey(tenantId, userId));
  const tasks: AppointmentTask[] = tasksJson ? JSON.parse(tasksJson) : [];

  return tasks;
};
